(() => {
  if (customElements.get('products-carousel-collection')) {
    return;
  }

  class ProductsCarouselCollection extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        waitForTransition: false,
        perPage: 4,
        pagination: false,
        breakpoints: {
          768: {
            perPage: 2
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('products-carousel-collection', ProductsCarouselCollection);
})();
